export default __webpack_public_path__ + "static/media/165-poland.241faeed.svg";